<div id="imageoneClient" *ngIf="imageoneClient">
    <imageone-client [pageDisplay]="pageDisplay" [pageTitle]="pageTitle" [id]="id">
    </imageone-client>
</div>